<template>
  <Icon :component="BackArrowSvg" />
</template>

<script lang="ts">
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import BackArrowSvg from './svg/BackArrowSvg.vue';

export default defineComponent({
  name: 'BackArrowIcon',
  components: {
    Icon
  },
  props: {},
  data() {
    return {
      BackArrowSvg: markRaw(BackArrowSvg)
    };
  }
});
</script>
